/**
 * @generated SignedSource<<dc37d8f02d79d635342324270bdcebf8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SearchBar_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useSearchSuggestions_viewer">;
  readonly " $fragmentType": "SearchBar_viewer";
};
export type SearchBar_viewer$key = {
  readonly " $data"?: SearchBar_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SearchBar_viewer">;
};

import SearchBarRefetchQuery_graphql from './SearchBarRefetchQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "hasQuery"
    },
    {
      "kind": "RootArgument",
      "name": "includeTypes"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "query"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": SearchBarRefetchQuery_graphql
    }
  },
  "name": "SearchBar_viewer",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "hasQuery",
          "variableName": "hasQuery"
        },
        {
          "kind": "Variable",
          "name": "query",
          "variableName": "query"
        }
      ],
      "kind": "FragmentSpread",
      "name": "useSearchSuggestions_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "5f05bc12d9567b8681785f7da2868f1a";

export default node;
